import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AppComponent } from './app.component';
import {
  PageNotFoundComponent,
  ContactUsComponent,
  LandingComponent,
  HomeComponent,
  ProfileViewComponent,
  ErrorPageComponent
} from '@app/shared';
import { AuthGuard } from './core/guards';

export const router: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', loadChildren: 'app/dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
      { path: 'tenants', loadChildren: 'app/tenant/tenant.module#TenantModule', canActivate: [AuthGuard] },
      {
        path: 'admin',
        loadChildren: 'app/admin/admin.module#AdminModule',
        canActivate: [AuthGuard],
      },
      { path: 'profile', component: ProfileViewComponent, canActivate: [AuthGuard], data: { title: 'My Profile' } },
      {
        path: 'access-card',
        loadChildren: 'app/access-card/access-card.module#AccessCardModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'event',
        loadChildren: 'app/event/event.module#EventModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'invoice',
        loadChildren: 'app/invoice/invoice.module#InvoiceModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'announcement',
        loadChildren: 'app/announcement/announcement.module#AnnouncementModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'supplier',
        loadChildren: 'app/suppliers/supplier.module#SupplierModule',
        canActivate: [AuthGuard],
      },
        {
        path: 'facility-and-maintenance',
        loadChildren: 'app/facility-and-maintenance/facility-and-maintenance.module#FacilityAndMaintenanceModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'venues',
        loadChildren: 'app/venue/venue.module#VenueModule',
        canActivate: [AuthGuard]
      },
    ]
  },
  { path: 'account', loadChildren: 'app/account/account.module#AccountModule' },
  { path: 'suppliers-registeration', loadChildren: 'app/suppliers-registeration/suppliers-registeration.module#SuppliersRegisterationModule' },

  {
    path: 'contact-us',
    component: LandingComponent,
    children: [
      { path: '', component: ContactUsComponent, data: { title: 'Contact Us' } },
    ]
  },
  { path: 'error', component: ErrorPageComponent, data: { title: 'Error' } },
  { path: '**', component: PageNotFoundComponent, data: { title: 'Not Found' }  },

];


@NgModule({
  imports: [
    RouterModule.forRoot(router, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts